<template>
    <div class="col-md-12">
        <div class="panel panel-visible" id="spy2">

            <div class="panel-heading">
                <div class="panel-title hidden-xs">
                    <span class="glyphicon glyphicon-tasks"></span>Записи на завтра</div>
            </div>
            <div class="panel-body pn">
                <grid-view
                        ref="grid"
                        :loader="loader"
                        store-name="visits-tomorrow-list"
                        defaultSort="-created_at"
                        :filter="filter"
                        :extraFields="['client', 'direction', 'room', 'schedule', 'creator']"
                >
                    <template #header>
                        <th>Клиент</th>
                        <th>Телефон</th>
                        <th>Направление</th>
                        <th>Зал</th>
                        <th>Время</th>
                        <th>Автор</th>
                        <th></th>
                    </template>
                    <template v-slot:row="{ row }">
                        <td>
                            <router-link :to="{name: 'clients-edit', params: {id: row.client.id}}" target="_blank">
                                {{row.client.fullName}}
                            </router-link>
                        </td>
                        <td>
                            {{row.client.phone ? row.client.phone : '---'}}
                        </td>
                        <td>{{row.direction ? row.direction.name : '---'}}</td>
                        <td>{{row.room.name}}</td>
                        <td>{{row.schedule.time_start}} - {{row.schedule.time_end}}</td>
                        <td>{{row.creator ? row.creator.fullName : '---'}}</td>
                        <td>
                            <drop-down-button classes="btn-info btn-xs">
                                <li>
                                    <a v-on:click="reservationRemove(row)">
                                        Удалить
                                    </a>
                                </li>
                            </drop-down-button>
                        </td>
                    </template>
                </grid-view>
            </div>
        </div>
    </div>
</template>

<script>
    import Visit from "../../models/v2/Visit";
    import moment from "moment";

    export default {
        components: {
            gridView: () => import('../data/table/GridView'),
            dropDownButton: () => import('../data/DropDownButton'),
        },
        data() {
            return {
                directions: [],
                filter: {
                    is_reservation: 1,
                    date: moment().add(1, 'day').format('YYYY-MM-DD'),
                },
                loader: Visit.getList,
            };
        },
        methods: {
            async reservationRemove(visit) {
                await visit.remove();
                this.$refs.grid.load();
            },
        },
        metaInfo() {
            return {
                title: 'Записи на завтра - список',
                meta: [
                    {vmid: 'description', name: 'description', content: ''},
                    {vmid: 'keywords', name: 'keywords', content: ''},
                ],
            };
        },
    }
</script>
